import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { _ } from '../../functions/translator.js';
import SendIcon from '@material-ui/icons/Send';

import { toggleSwitch, 
        popupChange, 
        popUpMenuChange, 
        selectedCardsGroupsChange, 
        standByCardsGroupsChange } from '../../actions/index.js';
import { ToggleActions } from '../../constants/constants.js';

class SendNewButton extends React.Component{

    handleClick = async () => {
        this.props.standByCardsGroupsChange([this.props.cardsGroup.id]);
        this.props.toggleSwitch(ToggleActions.RELEASE_DATE);
        this.props.selectedCardsGroupsChange([])
        this.props.popUpMenuChange({ 
            show: false,
            close: false, 
            closeList: false,
            expanded: false
        });
        this.props.popupChange('none');
    }

    render() {   
        return (
            <div>
                <p class="card-text center">{_('Puedes liberar este Registro para que sea revisado')}</p>
                <p class="center">
                    <button class="btn btn-outline-success btn-icon-text center" onClick={this.handleClick} style={{height: '30px'}} rel="noopener noreferrer"><SendIcon/> {_('Liberar')}</button>
                </p>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popupChange : popupChange,
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        toggleSwitch: toggleSwitch,
        standByCardsGroupsChange: standByCardsGroupsChange
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SendNewButton)